import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  format_date,
  GET,
  PUT,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  LEGAL_PAGES,
  LEGAL_LANGS,
  LEGAL_BLOCK_TYPES,
  LEGAL_TOKENS,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
  newBlock,
  withBlockIds,
  stripBlockIds,
  blockSummary,
} from "../../components/homepage_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/policy.css";

/* ============================================================================
 * จัดการหน้าแรก › นโยบายความเป็นส่วนตัว / ข้อกำหนดการใช้งาน
 *   /ad/home/privacy  -> เอกสารที่หน้า /policy-privacy แสดง
 *   /ad/home/terms    -> เอกสารที่หน้า /terms-of-use แสดง
 *
 * สองเมนูใช้หน้าจอเดียวกัน (props.kind เป็นตัวบอกว่าเอกสารฉบับไหน) เพราะเอกสาร
 * ทั้งคู่มีโครงเหมือนกันทุกอย่าง — หัวเอกสาร + หัวข้อที่เรียงลำดับได้ + บล็อกเนื้อหา
 * แยกเป็นสองไฟล์จะกลายเป็นโค้ดชุดเดียวกันสองชุดที่ต้องแก้คู่กันตลอด
 *
 * เอกสารเก็บสองภาษาในรายการเดียวกัน (title_th/title_en, blocks_th/blocks_en)
 * เพิ่ม/ลบ/เรียงลำดับหัวข้อทีเดียวจึงมีผลทั้งสองภาษา ไม่หลุดจากกัน
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/<kind>
 *   PUT  admin/homepage/<kind>   (ส่ง { doc, items })
 * บันทึกแบบแทนที่ทั้งชุด — แก้ในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

const EMPTY_FORM = () => ({
  key: "",
  highlight: false,
  is_active: true,
  title_th: "",
  title_en: "",
  blocks_th: [],
  blocks_en: [],
});

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeLegalSetting extends Component {
  constructor(props) {
    super(props);
    const page = LEGAL_PAGES[props.kind] || LEGAL_PAGES.privacy;
    const data = clone(EMPTY_GROUP[page.group]);

    this.state = {
      doc: data.doc,
      items: data.items,
      saved: clone(data),

      // ภาษาที่กำลังแก้อยู่ (คนละเรื่องกับภาษาของหน้าแอดมิน)
      lang: isTh() ? "th" : "en",

      modal_form: false,
      edit_uid: "",
      form: EMPTY_FORM(),
      updated_at: "",
      updated_by: "",
    };
  }

  page = () => LEGAL_PAGES[this.props.kind] || LEGAL_PAGES.privacy;

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* เปลี่ยนเมนูข้ามฉบับ (privacy <-> terms) โดยไม่ได้ unmount — โหลดของฉบับใหม่ */
  componentDidUpdate(prevProps) {
    if (prevProps.kind !== this.props.kind) {
      const data = clone(EMPTY_GROUP[this.page().group]);
      this.setState({ doc: data.doc, items: data.items, saved: clone(data), modal_form: false }, this.Get);
    }
  }

  Get = async () => {
    loading(true);
    const result = await GET(`admin/homepage/${this.page().group}`, {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) => {
    const doc = data.doc || clone(EMPTY_GROUP[this.page().group].doc);
    const items = data.items || [];
    this.setState({
      doc,
      items,
      saved: clone({ doc, items }),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });
  };

  current = () => ({ doc: this.state.doc, items: this.state.items });

  isDirty = () => JSON.stringify(this.current()) !== JSON.stringify(this.state.saved);

  /* หัวเอกสารของภาษาที่กำลังแก้อยู่ */
  head = () => this.state.doc[this.state.lang] || {};

  setHead = (patch) =>
    this.setState((prev) => ({
      doc: { ...prev.doc, [prev.lang]: { ...prev.doc[prev.lang], ...patch } },
    }));

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: EMPTY_FORM() });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: {
        key: item.key || "",
        highlight: !!item.highlight,
        is_active: item.is_active !== false,
        title_th: item.title_th || "",
        title_en: item.title_en || "",
        blocks_th: withBlockIds(item.blocks_th),
        blocks_en: withBlockIds(item.blocks_en),
      },
    });

  CloseForm = () => this.setState({ modal_form: false });

  /* ------------------------------------------------- แก้บล็อกในฟอร์ม (ทีละภาษา) */
  blockField = () => (this.state.lang === "en" ? "blocks_en" : "blocks_th");

  formBlocks = () => this.state.form[this.blockField()] || [];

  setBlocks = (updater) =>
    this.setState((prev) => {
      const field = prev.lang === "en" ? "blocks_en" : "blocks_th";
      return { form: { ...prev.form, [field]: updater(prev.form[field] || []) } };
    });

  AddBlock = (type) => this.setBlocks((blocks) => [...blocks, newBlock(type)]);

  SetBlock = (id, patch) =>
    this.setBlocks((blocks) => blocks.map((block) => (block._id === id ? { ...block, ...patch } : block)));

  RemoveBlock = (id) => this.setBlocks((blocks) => blocks.filter((block) => block._id !== id));

  MoveBlock = (id, step) =>
    this.setBlocks((blocks) => {
      const index = blocks.findIndex((block) => block._id === id);
      if (index < 0 || !blocks[index + step]) return blocks;
      const next = [...blocks];
      next.splice(index + step, 0, next.splice(index, 1)[0]);
      return next;
    });

  /* รายการย่อยของบล็อกชนิด ul */
  AddLine = (id) =>
    this.setBlocks((blocks) =>
      blocks.map((block) => (block._id === id ? { ...block, items: [...(block.items || []), { _id: newUid("li"), label: "", text: "" }] } : block))
    );

  SetLine = (id, lineId, patch) =>
    this.setBlocks((blocks) =>
      blocks.map((block) =>
        block._id === id
          ? { ...block, items: (block.items || []).map((item) => (item._id === lineId ? { ...item, ...patch } : item)) }
          : block
      )
    );

  RemoveLine = (id, lineId) =>
    this.setBlocks((blocks) =>
      blocks.map((block) => (block._id === id ? { ...block, items: (block.items || []).filter((item) => item._id !== lineId) } : block))
    );

  /* ------------------------------------------------------- บันทึกหัวข้อในฟอร์ม */
  SaveSection = () => {
    const { form, edit_uid } = this.state;
    if (!form.title_th.trim() && !form.title_en.trim()) return alert("", "warning", t("warning"), t("home_verify_legal_title"));

    const payload = {
      // หัวข้อภาษาไทยเป็นตัวหลักที่ backend บังคับ ไม่ได้กรอกก็ใช้ฉบับอังกฤษแทน
      title_th: form.title_th.trim() || form.title_en.trim(),
      title_en: form.title_en.trim(),
      key: form.key.trim(),
      highlight: form.highlight,
      is_active: form.is_active,
      blocks_th: stripBlockIds(form.blocks_th),
      blocks_en: stripBlockIds(form.blocks_en),
    };

    this.setState((prev) => ({
      items: edit_uid
        ? prev.items.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...prev.items, { ...payload, uid: newUid("lg"), sort: nextSort(prev.items) }],
      modal_form: false,
    }));
  };

  Move = (item, step) => this.setState((prev) => ({ items: moveItem(prev.items, item.uid, step) }));

  ToggleActive = (item) =>
    this.setState((prev) => ({
      items: prev.items.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)),
    }));

  Delete = async (item) => {
    const title = item.title_th || item.title_en;
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_legal_desc")}\n${title}`, t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ items: prev.items.filter((row) => row.uid !== item.uid) }));
  };

  Save = async () => {
    const { doc } = this.state;
    if (!doc.th.title.trim() && !doc.en.title.trim()) return alert("", "warning", t("warning"), t("home_verify_legal_doc_title"));
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT(`admin/homepage/${this.page().group}`, this.current());
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ doc: clone(prev.saved.doc), items: clone(prev.saved.items) }));
  };

  /* ================================================= render : ปุ่มสลับภาษา */
  renderLangTabs = () => (
    <div className="hmg-langs">
      {LEGAL_LANGS.map((item) => (
        <button
          key={item.value}
          type="button"
          className={`hmg-lang ${this.state.lang === item.value ? "is-on" : ""}`}
          onClick={() => this.setState({ lang: item.value })}
        >
          {t(item.label)}
        </button>
      ))}
    </div>
  );

  /* ====================================================== render : ตัวจัดการ */
  renderList = () => {
    const list = ordered(this.state.items);
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();
    const { lang } = this.state;
    const head = this.head();
    const en = lang === "en";

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_legal_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t("home_unit_topic")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_legal")}
              </button>
            )}
          </div>
        </div>

        {/* หัวเอกสาร — แยกตามภาษาที่เลือกจากแท็บ */}
        <div className="p-4 pb-2">
          <div className="d-flex justify-content-between align-items-center mb-3 gap-2 flex-wrap">
            <div className="prop-title text-14 mb-0">
              <span className="prop-title__dot" />
              {t("home_legal_head_title")}
            </div>
            {this.renderLangTabs()}
          </div>

          <div className="row g-3">
            <div className="col-md-8">
              <label className="prop-label">
                {t("home_legal_doc_title")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={120} value={head.title || ""} onChange={(e) => this.setHead({ title: e.target.value })} />
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("home_legal_updated")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={40}
                placeholder={en ? "9 August 2026" : "9 สิงหาคม 2569"}
                value={head.updated || ""}
                onChange={(e) => this.setHead({ updated: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_legal_doc_subtitle")}</label>
              <textarea
                className="prop-field"
                rows={2}
                style={{ height: "auto", paddingTop: "10px" }}
                maxLength={500}
                value={head.subtitle || ""}
                onChange={(e) => this.setHead({ subtitle: e.target.value })}
              />
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_legal_doc_lead")}</label>
              <textarea
                className="prop-field"
                rows={3}
                style={{ height: "auto", paddingTop: "10px" }}
                maxLength={2000}
                value={head.lead || ""}
                onChange={(e) => this.setHead({ lead: e.target.value })}
              />
              <div className="ppl-sub mt-1">{t("home_legal_doc_lead_hint")}</div>
            </div>

            <div className="col-12">
              <div className="ppl-note">
                <span className="icon">{ADMIN_ICON.info}</span>
                <div>
                  {t("home_legal_token_hint")}
                  <div className="hmg-tokens mt-2">
                    {LEGAL_TOKENS.map((token) => (
                      <span className="hmg-token" key={token}>
                        {token}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* หัวข้อของเอกสาร */}
        <div className="hmg-list border-top border-light">
          {list.map((item, index) => {
            const title = (en ? item.title_en : item.title_th) || item.title_th || item.title_en;
            const blocks = (en ? item.blocks_en : item.blocks_th) || [];
            const missing = en ? !item.title_en : !item.title_th;

            return (
              <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
                <div className="d-flex align-items-center gap-2">
                  <span className="pty-rank">{index + 1}</span>
                  <div className="pty-order">
                    <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.Move(item, -1)}>
                      {ADMIN_ICON.up}
                    </button>
                    <button
                      type="button"
                      className="pty-order__btn icon"
                      title={t("ptype_move_down")}
                      disabled={index === list.length - 1}
                      onClick={() => this.Move(item, 1)}
                    >
                      {ADMIN_ICON.down}
                    </button>
                  </div>
                </div>

                <div className="hmg-row__body">
                  <div className="hmg-row__title">
                    <span>{title}</span>
                    {item.highlight && <span className="hmg-tag hmg-tag--lime">{t("home_legal_highlight")}</span>}
                    {missing && <span className="hmg-tag">{t("home_legal_untranslated")}</span>}
                  </div>
                  <div className="hmg-row__desc">{blocks.map(blockSummary).filter(Boolean).join(" / ")}</div>
                  <div className="hmg-row__meta">
                    <span className="hmg-tag">
                      <span className="icon text-10">{ADMIN_ICON.list}</span>
                      {blocks.length} {t("home_unit_block")}
                    </span>
                    {!!item.key && (
                      <span className="hmg-tag">
                        <span className="icon text-10">{ADMIN_ICON.link}</span>#{this.page().anchor}-{item.key}
                      </span>
                    )}
                  </div>
                </div>

                {can("homepage.update") && (
                  <div className="hmg-row__actions">
                    <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                      <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                      <span className="ppl-switch__track" />
                    </label>
                    <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                      {ADMIN_ICON.edit}
                    </button>
                    <button
                      type="button"
                      className="prop-iconbtn icon"
                      style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                      title={t("delete")}
                      onClick={() => this.Delete(item)}
                    >
                      {ADMIN_ICON.trash}
                    </button>
                  </div>
                )}
              </div>
            );
          })}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.doc}</span>
              {t("home_empty_legal")}
            </div>
          )}
        </div>

        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  /* ใช้ CSS ชุดเดียวกับหน้าเอกสารจริง (policy.css) ผู้ดูแลจึงเห็นหน้าตาที่ผู้ชมจะเห็น
     ต่างแค่ยังไม่ได้แทนค่า {company_name} เป็นข้อมูลบริษัทจริง — คำแทนโชว์ตามที่พิมพ์ */
  renderPreviewBlock = (block, index) => {
    if (block.type === "note") {
      return (
        <p className="mn-policy__note" key={index}>
          {block.text}
        </p>
      );
    }
    if (block.type === "link") {
      return (
        <p key={index}>
          <span className="mn-policy__link">{block.text}</span>
        </p>
      );
    }
    if (block.type === "ul") {
      return (
        <ul key={index}>
          {(block.items || []).map((item, i) => (
            <li key={i}>
              {!!item.label && <span className="mn-policy__label">{item.label}</span>}
              {item.label && item.text ? " : " : ""}
              {item.text}
            </li>
          ))}
        </ul>
      );
    }
    return <p key={index}>{block.text}</p>;
  };

  renderPreview = () => {
    const { lang } = this.state;
    const en = lang === "en";
    const head = this.head();
    const list = ordered(this.state.items).filter((item) => item.is_active);
    const page = this.page();

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href={page.site} target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com{page.site}</span>
            </div>
            <div className="hmg-frame__body hmg-doc">
              <div className="mn-policy">
                <div className="mn-policy__head">
                  <h1 className="mn-policy__title">{head.title}</h1>
                  <p className="mn-policy__subtitle">{head.subtitle}</p>
                  {!!head.updated && (
                    <span className="mn-policy__updated">
                      {t("policy_updated")} : {head.updated}
                    </span>
                  )}
                </div>

                <div className="mn-policy__card">
                  {!!head.lead && <p className="mn-policy__lead">{head.lead}</p>}

                  {list.map((item) => {
                    const title = (en ? item.title_en : item.title_th) || item.title_th || item.title_en;
                    const blocks = (en ? item.blocks_en : item.blocks_th) || [];
                    return (
                      <section key={item.uid} className={`mn-policy__section${item.highlight ? " mn-policy__section--highlight" : ""}`}>
                        <h2 className="mn-policy__section-title">{title}</h2>
                        {blocks.map(this.renderPreviewBlock)}
                      </section>
                    );
                  })}

                  {!list.length && <div className="hmg-empty">{t("home_empty_legal")}</div>}
                </div>
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_legal_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  /* ============================================ render : ตัวแก้บล็อกเนื้อหา */
  renderBlockEditor = () => {
    const blocks = this.formBlocks();

    return (
      <div className="hmg-blocks">
        {blocks.map((block, index) => (
          <div className="hmg-block" key={block._id}>
            <div className="hmg-block__bar">
              <span className="hmg-block__no">{index + 1}</span>
              <select className="prop-field hmg-block__type" value={block.type} onChange={(e) => this.SetBlock(block._id, { type: e.target.value })}>
                {LEGAL_BLOCK_TYPES.map((item) => (
                  <option key={item.value} value={item.value}>
                    {t(item.label)}
                  </option>
                ))}
              </select>

              <div className="hmg-block__tools">
                <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.MoveBlock(block._id, -1)}>
                  {ADMIN_ICON.up}
                </button>
                <button
                  type="button"
                  className="pty-order__btn icon"
                  title={t("ptype_move_down")}
                  disabled={index === blocks.length - 1}
                  onClick={() => this.MoveBlock(block._id, 1)}
                >
                  {ADMIN_ICON.down}
                </button>
                <button
                  type="button"
                  className="prop-iconbtn icon"
                  style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                  title={t("delete")}
                  onClick={() => this.RemoveBlock(block._id)}
                >
                  {ADMIN_ICON.trash}
                </button>
              </div>
            </div>

            {block.type === "ul" ? (
              <div className="hmg-lines">
                {(block.items || []).map((item) => (
                  <div className="hmg-line" key={item._id}>
                    <input
                      type="text"
                      className="prop-field hmg-line__label"
                      maxLength={120}
                      placeholder={t("home_legal_line_label")}
                      value={item.label}
                      onChange={(e) => this.SetLine(block._id, item._id, { label: e.target.value })}
                    />
                    <input
                      type="text"
                      className="prop-field"
                      maxLength={500}
                      placeholder={t("home_legal_line_text")}
                      value={item.text}
                      onChange={(e) => this.SetLine(block._id, item._id, { text: e.target.value })}
                    />
                    <button
                      type="button"
                      className="prop-iconbtn icon"
                      style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                      title={t("delete")}
                      onClick={() => this.RemoveLine(block._id, item._id)}
                    >
                      {ADMIN_ICON.trash}
                    </button>
                  </div>
                ))}
                <button type="button" className="prop-btn prop-btn--ghost btn-sm" onClick={() => this.AddLine(block._id)}>
                  <span className="icon text-12">{ADMIN_ICON.plus}</span>
                  {t("home_legal_add_line")}
                </button>
                <div className="ppl-sub mt-1">{t("home_legal_line_hint")}</div>
              </div>
            ) : block.type === "link" ? (
              <div className="row g-2">
                <div className="col-md-5">
                  <input
                    type="text"
                    className="prop-field"
                    maxLength={300}
                    placeholder="/policy-privacy"
                    value={block.href}
                    onChange={(e) => this.SetBlock(block._id, { href: e.target.value })}
                  />
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    className="prop-field"
                    maxLength={255}
                    placeholder={t("home_legal_link_text")}
                    value={block.text}
                    onChange={(e) => this.SetBlock(block._id, { text: e.target.value })}
                  />
                </div>
              </div>
            ) : (
              <textarea
                className="prop-field"
                rows={3}
                style={{ height: "auto", paddingTop: "10px" }}
                maxLength={2000}
                placeholder={block.type === "note" ? t("home_legal_note_placeholder") : t("home_legal_text_placeholder")}
                value={block.text}
                onChange={(e) => this.SetBlock(block._id, { text: e.target.value })}
              />
            )}
          </div>
        ))}

        {!blocks.length && (
          <div className="hmg-empty">
            <span className="icon">{ADMIN_ICON.text}</span>
            {t("home_legal_empty_block")}
          </div>
        )}

        <div className="hmg-block__add">
          {LEGAL_BLOCK_TYPES.map((item) => (
            <button key={item.value} type="button" className="prop-btn prop-btn--ghost" onClick={() => this.AddBlock(item.value)}>
              <span className="icon text-12">{ADMIN_ICON.plus}</span>
              {t(item.label)}
            </button>
          ))}
        </div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form, lang } = this.state;
    const en = lang === "en";
    const titleField = en ? "title_en" : "title_th";

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="xl" centered scrollable>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div className="d-flex justify-content-between align-items-center w-100 gap-3 flex-wrap">
            <div>
              <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_legal") : t("home_add_legal")}</h5>
              <div className="text-secondary text-12">{t("home_legal_form_desc")}</div>
            </div>
            {this.renderLangTabs()}
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          <div className="row g-3">
            <div className="col-md-7">
              <label className="prop-label">
                {t("home_legal_topic_title")} ({t(en ? "lang_english" : "lang_thai")}) <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={255} value={form[titleField]} onChange={(e) => this.setForm({ [titleField]: e.target.value })} />
            </div>

            <div className="col-md-5">
              <label className="prop-label">{t("home_legal_anchor")}</label>
              <input
                type="text"
                className="prop-field"
                maxLength={60}
                placeholder="line"
                value={form.key}
                onChange={(e) => this.setForm({ key: e.target.value.replace(/[^a-z0-9_-]/gi, "").toLowerCase() })}
              />
              <div className="ppl-sub mt-1">{t("home_legal_anchor_hint")}</div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className="col-md-6">
              <label className="prop-label">{t("home_legal_highlight")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.highlight} onChange={(e) => this.setForm({ highlight: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className="text-12 text-secondary">{t("home_legal_highlight_hint")}</span>
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">
                {t("home_legal_blocks")} ({t(en ? "lang_english" : "lang_thai")})
              </label>
              {this.renderBlockEditor()}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveSection}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by } = this.state;
    const page = this.page();

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t(page.title)}</h3>
              <div className="text-secondary text-14">{t(page.desc)}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-xl-7 col-lg-7">{this.renderList()}</div>
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
